import React, { useRef, useState, useEffect, useMemo } from "react";
import { Skeleton, Tooltip } from "antd";
import isEqual from "react-fast-compare";
import accoArrow from "../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import { useSelector } from "react-redux";
const SectionTabsSkeleton = () => (
  <div className="DeepDiveDashboard__sectionTabs d-flex">
    {[1, 2, 3].map((_, idx) => (
      <div
        key={idx}
        className="DeepDiveDashboard__sectionTab bg__white border border-radius-4 mr-15"
        style={{
          width: 120,
          height: 36,
          display: "flex",
          alignItems: "center",
          justifyContent: "center", // ensures skeleton centers inside
          padding: "0 1rem",
        }}
      >
        <Skeleton.Button
          title={false}
          active={true}
          block={true} // 👈 fills 100% width automatically
          style={{
            height: 24, // or adjust based on actual design
            margin: 0,
          }}
        />
      </div>
    ))}
  </div>
);

const SectionTabs = ({
  sections = [],
  activeSectionId,
  onSectionChange,
  isLoading = false,
  isDisabled = false,
}) => {
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const sectionWrapperRef = useRef(null);
  const sectionListRef = useRef(null);

  const [windowWidths, setWindowWidths] = useState(window?.innerWidth);

  const getLeftPosi = () => {
    if (sectionListRef?.current?.getBoundingClientRect()) {
      return sectionListRef.current.getBoundingClientRect()?.left;
    }
    return 0;
  };

  // Calculate widths for scroll logic
  const widthOfList = () => {
    let itemsWidth = 0;
    if (sectionListRef?.current) {
      sectionListRef?.current?.childNodes?.forEach((element) => {
        itemsWidth += element?.clientWidth + 10;
      });
    }
    return itemsWidth;
  };

  const widthOfHidden = () => {
    if (sectionWrapperRef?.current) {
      return (
        sectionWrapperRef?.current?.getBoundingClientRect()?.width -
        widthOfList() -
        getLeftPosi() -
        40 // scrollbar width
      );
    }
    return 0;
  };

  // Scroll event for mouse wheel
  useEffect(() => {
    requestAnimationFrame(() => {
      const scrollContainer = sectionListRef?.current;
      if (!scrollContainer) return;
      const onWheel = (evt) => {
        evt.preventDefault();
        scrollContainer.scrollLeft += evt.deltaY;
      };
      scrollContainer.addEventListener("wheel", onWheel);
      return () => {
        scrollContainer.removeEventListener("wheel", onWheel);
      };
    });
  }, []);

  const setWindowDimensions = () => {
    setWindowWidths(window.innerWidth);
    widthOfHidden();
  };
  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
    // eslint-disable-next-line
  }, []);
  // Arrow click handlers
  const prevTabs = () => {
    requestAnimationFrame(() => {
      const scrollLeft = sectionListRef?.current?.scrollLeft;
      const itemWidth = parseInt(
        getComputedStyle(sectionListRef?.current?.children?.[0])?.width
      );
      sectionListRef.current.scrollLeft = scrollLeft - itemWidth * 2;
    });
  };
  const nextTabs = () => {
    requestAnimationFrame(() => {
      const scrollLeft = sectionListRef?.current?.scrollLeft;
      const itemWidth = parseInt(
        getComputedStyle(sectionListRef?.current?.children?.[0])?.width
      );
      sectionListRef.current.scrollLeft = scrollLeft + itemWidth * 2;
    });
  };

  // Don't need to show tabs in case of loading
  if (isLoading) {
    return null;
  }
  // if (isLoading) {
  //   return <SectionTabsSkeleton />;
  // }
  return (
    <div
      className="DeepDiveDashboard__sectionTabs d-flex align-items-center"
      ref={sectionWrapperRef}
    >
      {widthOfHidden() < 0 && (
        <button
          className="border-0 scroller"
          onClick={() => {
            if (!isDisabled) prevTabs();
          }}
          style={{ backgroundColor: "transparent" }}
          disabled={isDisabled}
          tabIndex={-1}
          aria-label="Scroll left"
        >
          <img
            src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
            className="accordionArrow p-0"
            alt="left"
            style={{ transform: "rotate(270deg)" }}
          />
        </button>
      )}
      <div
        className={`DeepDiveDashboard__carouselContainer ${
          widthOfHidden() < 0 ? "" : "m-0"
        }`}
        ref={sectionListRef}
        style={{
          maxWidth: widthOfHidden() < 0 && "calc(100% - 5.3rem)",
        }}
      >
        {Array.isArray(sections) &&
          sections?.map((section, section_index) => (
            <div
              key={section?.section_id}
              className={`DeepDiveDashboard__sectionTab ${
                activeSectionId === section?.section_id ? "active" : ""
              } ${isDisabled ? "disabled" : ""}`}
              onClick={() => {
                if (!isDisabled && activeSectionId !== section?.section_id)
                  onSectionChange(section, section_index);
              }}
            >
              {section?.section_name}
            </div>
          ))}
      </div>

      {widthOfHidden() < 0 && (
        <button
          className="border-0 scroller"
          onClick={() => {
            if (!isDisabled) nextTabs();
          }}
          style={{ backgroundColor: "transparent" }}
          disabled={isDisabled}
          tabIndex={-1}
          aria-label="Scroll right"
        >
          <img
            src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
            className="accordionArrow p-0"
            alt="right"
            style={{ transform: "rotate(90deg)" }}
          />
        </button>
      )}
    </div>
  );
};

export default React.memo(SectionTabs, isEqual);
